import React from 'react';
import 'firebase/firestore';
import SectionDisplay from './SectionDisplay';
import CourseBasicInfoDisplay from './CourseBasicInfoDisplay';
import { InfoDisplayProps } from './infoDisplayProps';

const CourseInfoDisplay: React.FC<InfoDisplayProps> = ({ courseData, instructorData }) => {
  return (
    <>
      <CourseBasicInfoDisplay courseData={courseData} instructorData={instructorData} />
      <div className='mt-4'>
        <p>Prerequisites: {courseData.prereqNotes}</p>
      </div>
      <div className='mt-4'>
        <SectionDisplay section={courseData.sections[0]} sectionNumber={1}></SectionDisplay>
        {courseData.sections[1] ? (
          <SectionDisplay section={courseData.sections[1]} sectionNumber={2}></SectionDisplay>
        ) : null}
      </div>
      <div className='mt-4'>
        <p>Course Description: {courseData.description}</p>
      </div>
      <div className='mt-4'>
        <p className='inline-block'>Student Cap: {courseData.studentCountInfo.recommended}</p>
        <p className='inline-block ml-8'>Student Abs. Max: {courseData.studentCountInfo.max}</p>
        <p className='inline-block ml-8'>
          Grades: {courseData.gradeInfo.regular.min} to {courseData.gradeInfo.regular.max}
        </p>
        <p className='inline-block ml-8'>
          Grades (exception): {courseData.gradeInfo.exception.min} to{' '}
          {courseData.gradeInfo.exception.max}
        </p>
      </div>
      <div className='mt-4'>
        <p>
          Curriculum:{' '}
          {courseData.curriculumFiles.map((f, index) => (
            <a className='link-blue' href={f.url} key={index}>
              {f.filename}
            </a>
          ))}
        </p>
      </div>
    </>
  );
};

export default CourseInfoDisplay;
